module.exports = __webpack_public_path__ + "assets/img/18_183.c02bac0f.jpg";